import {makeAutoObservable} from 'mobx';
import {State} from '../../entity/model/state';
import StateAgent from '../agent/state-agent';

export default class StateStore {
  states: State[] = [];
  cache: boolean = false;
  stateAgent: StateAgent;

  constructor(stateAgent: StateAgent) {
    makeAutoObservable(this);
    this.stateAgent = stateAgent;
  }

  getStates = async (): Promise<State[]> => {
    try {
      this.states = await this.stateAgent.getStates();
      this.cache = true;
    } catch (error: any) {
      console.error('Error occurred while loading the states', error)
    }

    return this.states;
  }

}
